export default __webpack_public_path__ + "static/media/eps.8fee57ed.svg";